import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query TeamMatrixSettings($teamId: ID!) {
  teamMatrixSettings(teamId: $teamId) {
    allRequestTypesOn
    allChannelsOn
    requestTypesIds
    channelsIds
  }
}`;

export function parseTeamMatrixSettings(data) {
  return {
    allChannelsOn: data.allChannelsOn,
    allSkillsOn: data.allRequestTypesOn,
    channelsIds: data.channelsIds,
    skillsIds: data.requestTypesIds,
  };
}

function getTeamMatrixSettings(teamId) {
  return apollo.client.query({
    query,
    variables: { teamId },
    fetchPolicy: 'network-only',
  }).then((res) => parseTeamMatrixSettings(res.data.teamMatrixSettings));
}

export default getTeamMatrixSettings;
